import { onlineManager } from '@tanstack/react-query';
import { onlineOrderRepositoryOfflineAdapters } from '../../../offline/offlineRequestAdapters/onlineOrder.repository.offlineAdapters';
import { onlineOrdersRepository } from './onlineOrdersRepository';

export const ordersRepository = (id?: string, isOfflineMode?: boolean) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineOrderRepositoryOfflineAdapters(id)
    : onlineOrdersRepository(id);
